(function() { window.GUID_9c1e05d8_fe9b_4a2f_8d14_792f36085522 = { getGuid: function() { return "9c1e05d8-fe9b-4a2f-8d14-792f36085522"; } }; })();
var CS;
(function (CS) {
    var App;
    (function (App) {
        var Views;
        (function (Views) {
            var _Shared;
            (function (_Shared) {
                var WallSections;
                (function (WallSections) {
                    CS.Controls.Accordion.Events.Ready({
                        selector: "body",
                        childSelector: ".accordion-quick-tournaments",
                        callback: (accordion, e) => {
                            CS.DOM.$body.offon("click.deleteQuickTournament", "#popup-quick-tournament-delete", (e) => {
                                const $popup = $(e.currentTarget);
                                const $target = $(e.target);
                                const isDeleteClick = $target.closest("#button-delete-quick-tournament").length > 0;
                                const isCancelClick = $target.closest("#button-delete-quick-tournament-cancel").length > 0;
                                //const popup = Controls.GetInstance(Controls.Popup, $popup, true);
                                const popup = CS.Controls.GetInstance(CS.Controls.Popup, $("#popup-quick-tournament"), true);
                                if (isDeleteClick) {
                                    const { quickTournamentId } = $target.closest("#button-delete-quick-tournament").data("html");
                                    if (quickTournamentId) {
                                        WallSections.QuickTournamentsSection.RemoveQuickTournament(quickTournamentId, accordion.$Container.find(`[data-quick-tournament-id="${quickTournamentId}"]`));
                                        //if (accordion.$Container.find(`.quicktournament-row[data-quick-tournament-id="${quickTournamentId}"]`).length) {
                                        //    accordion.$Container.find(`.quicktournament-row[data-quick-tournament-id="${quickTournamentId}"]`).remove();
                                        //}
                                        if (popup != null) {
                                            popup.Close();
                                        }
                                    }
                                }
                                else if (isCancelClick) {
                                    if (popup != null) {
                                        popup.Close();
                                    }
                                }
                            });
                        }
                    });
                })(WallSections = _Shared.WallSections || (_Shared.WallSections = {}));
            })(_Shared = Views._Shared || (Views._Shared = {}));
        })(Views = App.Views || (App.Views = {}));
    })(App = CS.App || (CS.App = {}));
})(CS || (CS = {}));

//# sourceMappingURL=quick-tournaments-section.ready.js.map
